import { Button, useTheme } from "@mui/material";
import { CartContext } from "./provider.js";
import { ChevronRight } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import React from "react";
export const AddToCartButton = ({ buttonProps, label, productId = "", }) => {
    const { t } = useTranslation(["c-cart", "c-common"]);
    const theme = useTheme();
    const { addItemAsync, disableInteraction, isLoading } = React.useContext(CartContext);
    const [added, setAdded] = React.useState(false);
    const handleClick = async () => {
        try {
            await addItemAsync({ id: productId, quantity: 1 });
            setAdded(true);
        }
        catch (error) {
            // do nothign as we handle the error inside the cart provider
        }
    };
    return (React.createElement(React.Fragment, null, added ? (React.createElement(Button, { "data-testid": "go-to-cart-btn", endIcon: React.createElement(ChevronRight, null), href: t("c-common:url-cart", "/warenkorb"), LinkComponent: Link, variant: "contained", ...buttonProps, sx: {
            backgroundColor: "white !important",
            color: theme.palette.primary.dark,
            ...(buttonProps?.sx ?? {}),
        } }, t("button-label-go-to-cart", "Warenkorb anzeigen"))) : (React.createElement(LoadingButton, { color: "primary", "data-testid": "add-to-cart-btn", endIcon: React.createElement(ChevronRight, null), disabled: !isLoading.addItem && disableInteraction, loading: isLoading.addItem, loadingPosition: "center", onClick: handleClick, variant: "contained", ...buttonProps, sx: {
            "&.MuiLoadingButton-root": {
                backgroundColor: "white",
                ".MuiLoadingButton-loadingIndicator": {
                    color: `${theme.palette.primary.dark} !important`,
                },
            },
            ...(buttonProps?.sx ?? {}),
        } }, !!label ? label : t("c-cart:button-label-add-to-cart", "In den Warenkorb")))));
};
//# sourceMappingURL=add-to-cart-button.js.map